import { createContext, useContext, type ReactNode } from "react";
import { useAlerts, type ExternalAlert } from "../hooks/useAlerts";
import { useTelemetryContext } from "./TelemetryContext";
import type { AlertRule, FiredAlert } from "../types/alerts";

interface AlertContextValue {
  alerts: FiredAlert[];
  toasts: FiredAlert[];
  acknowledgeAlert: (id: string) => void;
  dismissToast: (id: string) => void;
  clearAlerts: () => void;
  raise: (alert: ExternalAlert) => void;
  muted: boolean;
  setMuted: (muted: boolean) => void;
}

const AlertContext = createContext<AlertContextValue | null>(null);

export function AlertProvider({
  rules,
  topicPrefix,
  children,
}: {
  rules: AlertRule[];
  topicPrefix: string;
  children: ReactNode;
}) {
  const { metrics, publish } = useTelemetryContext();
  const alertState = useAlerts(rules, metrics, publish, topicPrefix);
  return (
    <AlertContext.Provider value={alertState}>
      {children}
    </AlertContext.Provider>
  );
}

export function useAlertContext(): AlertContextValue {
  const ctx = useContext(AlertContext);
  if (!ctx) {
    throw new Error("useAlertContext must be used within an AlertProvider");
  }
  return ctx;
}
